// Utility to convert hex color to [r, g, b, a] (all 0-255), supporting #RGB, #RGBA, #RRGGBB, #RRGGBBAA
export function hexToRgbaArray(hex: string): [number, number, number, number] {
  const fullHex = hex.replace('#', '');
  let r = 0, g = 0, b = 0, a = 255;

  if (fullHex.length === 3) {
    // #RGB
    r = parseInt(fullHex[0] + fullHex[0], 16);
    g = parseInt(fullHex[1] + fullHex[1], 16);
    b = parseInt(fullHex[2] + fullHex[2], 16);
  } else if (fullHex.length === 4) {
    // #RGBA
    r = parseInt(fullHex[0] + fullHex[0], 16);
    g = parseInt(fullHex[1] + fullHex[1], 16);
    b = parseInt(fullHex[2] + fullHex[2], 16);
    a = parseInt(fullHex[3] + fullHex[3], 16);
  } else if (fullHex.length === 6) {
    // #RRGGBB
    r = parseInt(fullHex.slice(0, 2), 16);
    g = parseInt(fullHex.slice(2, 4), 16);
    b = parseInt(fullHex.slice(4, 6), 16);
  } else if (fullHex.length === 8) {
    // #RRGGBBAA
    r = parseInt(fullHex.slice(0, 2), 16);
    g = parseInt(fullHex.slice(2, 4), 16);
    b = parseInt(fullHex.slice(4, 6), 16);
    a = parseInt(fullHex.slice(6, 8), 16);
  }

  return [r, g, b, a];
} 